import { CircularProgress } from "components/Progress/CircleProgressbar";
import { SurveyTagLabel } from "constants/enums/StudentSurveyEnum";
import { uniq } from "lodash";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Modal } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import apiCall from "services/apiCall";
import { surveyResult } from "services/survey-service";
import Select from "react-select";
import { updateAvailableSurvey } from "store/slices/userSlice";

function SurveySubmitModal({
  show,
  onHide,
  survey,
  answer,
  categoryList,
  questionCommentList,
  tagList,
  closeSurveyModal
}) {
  const [loading, setLoading] = useState(false);
  const user = useSelector((state) => state.user);
  const [missingTagList, setMissingTagList] = useState([]);
  const [favoriteTeacherList, setFavoriteTeacherList] = useState([]);
  const availableSurveys = useSelector((state) => state?.user?.availableSurvey);
  const dispatch = useDispatch();

  useEffect(() => {
    getMissingList();
  }, [JSON.stringify(answer)]);

  const getMissingList = () => {
    const tempMissingList = [];
    if (Array.isArray(categoryList) && categoryList.length) {
      categoryList.forEach((category) => {
        let isMinComplatet = false;
        category.tagList.forEach((tag) => {
          const tagAnserw = answer.filter(
            (_answer) =>
              _answer?.taggedId === tag?.taggedId && _answer?.branchInfo?.id === tag?.branch
          ).length;

          if (tagAnserw > 0 && tagAnserw < category.questionCount) {
            tempMissingList?.push(tag);
            isMinComplatet = true;
          } else if (tagAnserw > 0 && tagAnserw === category.questionCount) {
            isMinComplatet = true;
          }
        });

        if (!isMinComplatet && Array.isArray(category.tagList)) {
          category.tagList.forEach((p) => tempMissingList.push(p));
        }
      });
    }

    setMissingTagList(uniq(tempMissingList));
  };

  const submit = async () => {
    const totalScore = answer?.reduce(
      (prev, now) => (typeof now?.score === "number" ? prev + now.score : prev),
      0
    );
    const winnerIndicator = survey.indicators.find(
      (indicator) => indicator?.min < totalScore && indicator.max > totalScore
    );
    const submitParams = {
      nameAndSurname: `${user?.identity?.name} ${user?.identity?.surname}`,
      roleId: user?.selectedAuthorization?.id,
      roleType: user?.selectedAuthorization?.roleType,
      schoolInfo: {
        classId: user?.selectedAuthorization?.details?.classInfo?.id,
        className: user?.selectedAuthorization?.details?.classInfo?.name,
        schoolId: user?.selectedAuthorization?.details?.schoolInfo?.id,
        schoolName: user?.selectedAuthorization?.details?.schoolInfo?.name,
        campusId: user?.selectedAuthorization?.details?.campusInfo?.id,
        campusName: user?.selectedAuthorization?.details?.campusInfo?.name,
        corporationId: user?.selectedAuthorization?.details?.corporationInfo?.id,
        corporationName: user?.selectedAuthorization?.details?.corporationInfo?.name
      },
      surveyId: survey?.id,
      answers: answer.map((_answer) => ({
        ..._answer,
        questionComment:
          questionCommentList.find(
            (_comment) =>
              _comment?.taggedId === _answer?.taggedId &&
              _comment?.questionId === _answer?.questionId
          )?.comment || ""
      })),
      totalScore,
      winnerIndicator,
      myFavoriteTeachers: favoriteTeacherList.map((teacher) => {
        return {
          branchInfo: {
            code: teacher?.description,
            id: teacher?.branch,
            name: teacher?.description || teacher?.tag
          },
          teacherName: teacher?.taggedName,
          teacherRoleId: teacher?.taggedId,
          teacherSurname: ""
        };
      })
    };

    setLoading(true);
    await apiCall({
      service: surveyResult,
      serviceParams: submitParams,
      onSuccess: (res) => {
        if (availableSurveys?.length > 0)
          dispatch(
            updateAvailableSurvey(availableSurveys?.filter((_survey) => _survey?.id !== survey?.id))
          );
        if (typeof closeSurveyModal === "function") {
          closeSurveyModal();
        }
        onHide();
      }
    });
    setLoading(false);
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header>Anketi/Envanteri Tamamla</Modal.Header>
      <Modal.Body>
        {missingTagList.length ? (
          <>
            <div className="fc-scroller" style={{ overflowY: "auto", maxHeight: 350 }}>
              {missingTagList.map((missing) => (
                <div
                  key={missing?.taggedId}
                  className="rounded shadow-sm p-2 mb-4 d-flex justify-content-between"
                >
                  <div>
                    <p className="p-0 m-0 lms-font-bold">
                      {missing?.description || SurveyTagLabel[missing?.tag] || "-"}
                    </p>
                    <p
                      className="p-0 m-0"
                      style={{
                        fontSize: 18,
                        color: "#646E78"
                      }}
                    >
                      {missing?.taggedName}
                    </p>
                  </div>
                  <CircularProgress
                    label
                    value={
                      // işarateli / hepsi * 100
                      (answer.filter(
                        (_answer) =>
                          _answer?.taggedId === missing?.taggedId &&
                          _answer?.branchInfo?.id === missing?.branch
                      )?.length /
                        categoryList.find((category) =>
                          category.tagList.find((ct) => ct?.tag === missing?.tag)
                        )?.questionCount) *
                      100
                    }
                  />
                </div>
              ))}
            </div>
          </>
        ) : (
          <>
            <span>
              Anketi tamamlamak istediğinden emin misin? Tamamlanan ankete tekrar işaretleme
              yapamazsın.
            </span>

            {survey?.myFavoriteTeachersField && missingTagList.length < 1 && (
              <div className="my-4">
                <label>Favori Öğretmenlerim</label>
                <Select
                  options={tagList.filter(({ tag }) => tag === "TEACHER") || []}
                  onChange={setFavoriteTeacherList}
                  getOptionLabel={(option) => option?.taggedName}
                  getOptionValue={(option) => option?.taggedId}
                  placeholder="Favori Öğretmenlerim"
                  value={favoriteTeacherList}
                  isMulti
                  isOptionDisabled={() => favoriteTeacherList.length >= 3}
                />
              </div>
            )}
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <button
          id="dialog-cancel"
          type="button"
          onClick={onHide}
          className="btn btn-light btn-elevate mr-2"
          disabled={loading}
        >
          <FormattedMessage id="DIALOG.CANCEL" />
        </button>
        <button
          id="dialog-confirmdelete"
          type="button"
          onClick={() => {
            if (missingTagList.length > 0) {
              setMissingTagList([]);
            } else {
              submit();
            }
          }}
          className={`btn ${missingTagList.length > 0 ? "btn-danger" : "btn-light-primary"} `}
          disabled={loading}
        >
          <FormattedMessage id={missingTagList.length > 0 ? "Yinede Bitir" : "DIALOG.OK"} />
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default SurveySubmitModal;
